import { useMediaQuery, useTheme } from '@mui/material';
import { FC } from 'react';

import { LoginDrawer } from './login-drawer';
import { LoginDrawerProps } from './login-drawer/types';
import { LoginModal } from './login-modal';
import { LoginModalProps } from './login-modal/types';

export const LoginDialog: FC<LoginDrawerProps | LoginModalProps> = (props) => {
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('lg'));

    return isSmallScreen ? <LoginDrawer {...props} /> : <LoginModal {...props} />;
};
